import { env, buildApiUrl, isDevelopmentEnv } from '@/shared/config/env';

export async function fetchApi<T>(url: string, options: RequestInit = {}): Promise<T> {
  const API_CLIENT_ID = env.apiClientId || '';
  const CSRFTOKEN = env.apiCsrfToken || '';
  const DEVELOPMENT = isDevelopmentEnv();

  const isFormData = options.body instanceof FormData;
  const isPiccoloApi = url.startsWith('/admin/api/tables/');
  let fullUrl = url;
  let csrftoken = DEVELOPMENT
    ? CSRFTOKEN
    : document.cookie.split('; ').find(row => row.startsWith('csrftoken='))?.split('=')[1] || '';

  // TEST
  if (DEVELOPMENT) {
    document.cookie = `csrftoken=${CSRFTOKEN}`;
    document.cookie = `id=${API_CLIENT_ID}`;
  }

  fullUrl = buildApiUrl(fullUrl);

  const headers = {
    ...(!isFormData && { 'Content-Type': 'application/json' }),
    "accept": "application/json, text/plain, */*",
    "accept-language": "en-GB,en-US;q=0.9,en;q=0.8,ru;q=0.7",
    'x-csrftoken': csrftoken,
  };

  const response = await fetch(fullUrl, {
    ...options,
    headers: {
      ...headers,
      ...options.headers,
    },
    credentials: 'include',
  });

  if (response.status === 204) {
    return null as T;
  }

  const data = await response.json();

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error(data.detail || 'Unauthorized');
    }
    // Create error with status code attached
    const error = new Error(`Request failed: ${data.detail || response.statusText}`) as Error & { status?: number; detail?: string };
    error.status = response.status;
    error.detail = data.detail;
    throw error;
  }

  if (isPiccoloApi) {
    return data as T;
  }

  return data;
}
